import * as jsxRuntime from "/Users/matt/Documents/Revolve/Development/Billing-Application-Fnt-End/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment